<template>
  <div class="row">
    <div class="d-flex justify-content-center w-100">
      <div style="min-width: 612px;">
        <div class="card" style="margin-top:30px">
          <div style="margin-left:40px;margin-right:40px">
            <div v-if="!showDocument">
              <div class="thesisTitle" style="margin-top:40px;margin-bottom:25px">{{title}}</div>
              <div class="row">
                <div class="col-6">
                  <div class="thesisLabels">
                    Fund Name
                    <span class="required">*</span>
                  </div>
                  <input
                    type="text"
                    placeholder="Fund Name"
                    class="form-control"
                    v-model="thesisData.name"
                    @keyup="validations"
                  />
                </div>
                <div class="col-6">
                  <div class="thesisLabels">
                    Status
                    <span class="required">*</span>
                  </div>
                  <el-select
                    class="todo-dropdown-el-select"
                    size="large"
                    placeholder="Status"
                    v-model="thesisData.status"
                    @change="validations"
                  >
                    <el-option
                      v-for="item in statusDropdown"
                      :value="item.value"
                      :label="item.label"
                      :key="item.label"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="thesisLabels">
                    Fund Size
                    <span class="required">*</span>
                  </div>
                  <input
                    type="number"
                    placeholder="Fund Size"
                    class="form-control"
                    min="0"
                    v-model="thesisData.size"
                    @keyup="validations"
                  />
                </div>
                <div class="col-3">
                  <div class="thesisLabels">Vintage</div>
                  <input
                    type="text"
                    placeholder="Vintage"
                    class="form-control"
                    v-model="thesisData.vintage"
                  />
                </div>
                <div class="col-3 pl-0">
                  <div class="thesisLabels">Fund Term</div>
                  <input
                    type="number"
                    placeholder="Fund Term"
                    class="form-control"
                    v-model="thesisData.term"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="thesisLabels">
                    GP Ownership %
                    <span class="required">*</span>
                  </div>
                  <input
                    type="number"
                    placeholder="GP Ownership %"
                    class="form-control"
                    min="0.1"
                    max="100"
                    v-model="thesisData.gpOwnership"
                    @keyup="validations"
                  />
                </div>
                <div class="col-6">
                  <div class="thesisLabels">
                    Carry %
                    <span class="required">*</span>
                  </div>
                  <input
                    type="number"
                    placeholder="Carry %"
                    class="form-control"
                    min="1"
                    max="100"
                    v-model="thesisData.gpCarryProfit"
                    @keyup="validations"
                  />
                </div>
              </div>
              <div class="row" style="display:none">
                <div class="col-6">
                  <div class="thesisLabels">Start Date</div>
                  <input
                    class="todo-form-date todo-form form-control"
                    type="date"
                    :value="thesisData.startDate && moment.utc(thesisData.startDate).format('YYYY-MM-DD')?moment.utc(thesisData.startDate).format('YYYY-MM-DD'):moment.utc(new Date()).format('YYYY-MM-DD')"
                    @input="thesisData.startDate = moment($event.target.valueAsDate)"
                  />
                </div>
                <div class="col-6">
                  <div class="thesisLabels">End Date</div>
                  <input
                    class="todo-form-date todo-form form-control"
                    type="date"
                    :value="thesisData.endDate && moment.utc(thesisData.endDate).format('YYYY-MM-DD')?moment.utc(thesisData.endDate).format('YYYY-MM-DD'):moment.utc(new Date()).format('YYYY-MM-DD')"
                    @input="thesisData.endDate = moment($event.target.valueAsDate)"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <div class="thesisLabels" style="margin-bottom:4px">Sector</div>
                  <multiselect
                    v-model="sectorValues"
                    :options="availableSectors"
                    :multiple="true"
                    :custom-label="customLabel"
                    placeholder="Sectors"
                    class="filtersMultiselectDropdown sectorStatusMultiselectDropdown"
                  ></multiselect>
                </div>
                <div class="col-6">
                  <div class="thesisLabels" style="margin-bottom:4px">Stage</div>
                  <multiselect
                    v-model="stageValues"
                    :options="availableStages"
                    :multiple="true"
                    :custom-label="customLabel"
                    placeholder="Stages"
                    class="filtersMultiselectDropdown sectorStatusMultiselectDropdown"
                  ></multiselect>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="thesisLabels" style="margin-top:10px">Investment Check Size</div>
                  <div style="margin-bottom:10px">
                    <ejs-slider
                      id="default"
                      :min="min"
                      :max="max"
                      :step="step"
                      :ticks="ticks"
                      :tooltip="tooltip"
                      :mintyp="mintype"
                      :type="type"
                      :value="value"
                      cssClass="createWorkspaceSlider"
                      :renderingTicks="renderingTicks"
                      :tooltipChange="tooltipChange"
                      :change="sizeChange"
                    ></ejs-slider>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-top:10px">
                <div class="col-6">
                  <div class="thesisLabels">Fund Location</div>
                  <input
                    type="text"
                    placeholder="Fund Location"
                    class="form-control"
                    v-model="thesisData.location"
                  />
                </div>
                <div class="col-6">
                  <div class="thesisLabels">Investment Geography</div>
                  <input
                    type="text"
                    placeholder="Investment Geography"
                    class="form-control"
                    v-model="thesisData.geography"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="thesisLabels">Secret Sauce</div>
                  <textarea
                    placeholder="This is where you add your fund’s strategic differentiator including your insights into the sectors or market opportunity based on your experience or your “special sauce”. This area needs to show why you are uniquely qualified to execute on this fund, and how you are creating proprietary deal flow with your fund. For example: East Coast fin-tech startups from my 15 years of experience working in the financial and banking areas within the San Francisco bay area."
                    required="required"
                    rows="8"
                    cols="50"
                    class="form-control"
                    v-model="thesisData.secretSauce"
                  ></textarea>
                </div>
              </div>
              <div class="col-12 d-flex" style="padding: 0px;">
                <div
                  class="col-xl edit-company-action-button-row"
                  style="padding:0px;margin-bottom:30px"
                >
                  <button
                    type="submit"
                    @click.prevent="handleSave"
                    class="todo-form-submit-button btn btn-primary"
                    style="height:35px;margin-right:0px"
                    :disabled="showSpinner || saveDisable"
                  >
                    Save
                    <b-spinner v-if="showSpinner" style="float: right;" small label="Loading..."></b-spinner>
                  </button>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="thesisTitle" style="margin-top:40px;margin-bottom:25px">Description</div>
              <div class="thesisDescriptionLayout">
                <div style="padding:15px" class="thesisDescriptionText">{{descriptionText}}</div>
              </div>
              <div class="col-12 d-flex" style="padding: 0px;margin-top:30px">
                <div
                  class="col-xl edit-company-action-button-row"
                  style="padding:0px;margin-bottom:30px"
                >
                  <button
                    v-if="showEditButton"
                    type="button"
                    @click.prevent="handleEditThesis"
                    class="nextBtn"
                    style="height:35px;margin-right:0px"
                  >Edit</button>
                  <button
                    v-if="showNextButton"
                    type="button"
                    class="ml-2 todo-form-submit-button btn btn-primary"
                    @click="navigateNext()"
                  >Next</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlider from "vue-slider-component";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import "vue-slider-component/theme/default.css";
import {
  formatCurrency,
  vals,
  formatNumber,
  formatNumberWithComma,
} from "../../../util";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
import moment from "moment";

export default {
  name: "thesisTab",
  components: {
    VueSlider,
    Multiselect,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      vals,
      sectorValues: [],
      stageValues: [],
      value: [500000, 4000000],
      showSpinner: false,
      saveDisable: false,
      statusDropdown: [
        {
          label: "Fundraising",
          value: "Fundraising",
        },
        {
          label: "Deploying",
          value: "Deploying",
        },
        {
          label: "Managing",
          value: "Managing",
        },
        {
          label: "Wind Down",
          value: "Wind Down",
        },
        {
          label: "Closed",
          value: "Closed",
        },
      ],
      thesisData: {},
      thesisRecords: [],
      title: "",
      showDocument: true,
    };
  },
  computed: {
    ...mapGetters("user", ["currency"]),
    ...mapGetters("workspace", ["workspaces"]),
    ...mapGetters("portfolio", ["portfolioData"]),
    ...mapGetters("role", ["getCurrentWorkspaceRolePermissions"]),
    moment() {
      return moment;
    },
    availableSectors() {
      return this.vals.SECTOR_DEFINES.filter(
        (opt) => this.sectorValues.indexOf(opt) === -1
      );
    },
    availableStages() {
      return this.vals.WORKSPACE_STAGES.filter(
        (opt) => this.stageValues.indexOf(opt) === -1
      );
    },
    descriptionText() {
      let name = this.thesisData.name ? this.thesisData.name : "Unknown";
      let size = this.thesisData.size
        ? this.formatCurrency(this.thesisData.size, this.currency.ref, 0, true)
        : "Unknown";
      let location = this.thesisData.location
        ? this.thesisData.location
        : "Unknown";
      let geography = this.thesisData.geography
        ? this.thesisData.geography
        : "Unknown";
      let secretSauce = this.thesisData.secretSauce
        ? this.thesisData.secretSauce
        : "";
      let stage =
        this.stageValues && this.stageValues.length > 0
          ? this.stageValues.toString()
          : "General";
      let sector =
        this.sectorValues && this.sectorValues.length > 0
          ? this.sectorValues.toString()
          : "General";
      let retVal = `"${name} is a ${size} ${stage} fund in ${location} to fund ${geography} in ${sector} companies ${secretSauce}"`;
      return retVal;
    },
    portfolioValue() {
      // sum up our portfolio value
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.value)) sum += item.value;
        });
      }
      return sum;
    },
    portfolioCost() {
      // sum up our porfolio cost
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.cost)) sum += item.cost;
        });
      }
      return sum;
    },
    showNextButton() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "SHOW LP ALLOCATIONS") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
    showEditButton() {
      let rolePermissions = this.getCurrentWorkspaceRolePermissions;
      let index = rolePermissions.findIndex((item) => {
        if (item == "ADD THESIS") {
          return item;
        }
      });
      return index >= 0 ? true : false;
    },
  },
  methods: {
    formatCurrency: formatCurrency,
    navigateNext() {
      this.$parent.$parent.$parent.tabIndex = 0;
    },
    customLabel(option) {
      return `${option}`;
    },
    renderingTicks: function (args) {
      args.text = this.formatCurrency(args.value, this.currency.ref, 0, true);
    },
    tooltipChange: function (args) {
      let min, max;
      if (args.value && args.value.length >= 2) {
        min = formatNumberWithComma(args.value[0]);
        max = formatNumberWithComma(args.value[1]);
        // min = this.formatCurrency(args.value[0], this.currency.ref, 0, true);
        // max = this.formatCurrency(args.value[1], this.currency.ref, 0, true);
      }
      if (min && max) args.text = `$${min} - $${max}`;
    },
    roundNumber(value) {
      if (value <= 10) return (value / 10).toFixed() * 10;
      else if (value > 10 && value <= 999) return (value / 100).toFixed() * 100;
      else if (value >= 1000) return (value / 100).toFixed() * 100;
    },
    handleSave() {
      const self = this;
      this.showSpinner = true;
      let serverData = JSON.parse(JSON.stringify(this.thesisData));
      serverData.size = Number(serverData.size);
      serverData.sectors = this.sectorValues;
      serverData.stages = this.stageValues;
      serverData.checkSizeMin =
        this.value.length >= 1 && this.value[0]
          ? this.roundNumber(this.value[0])
          : "";
      serverData.checkSizeMax =
        this.value.length >= 1 && this.value[1]
          ? this.roundNumber(this.value[1])
          : "";
      serverData.gpOwnership = Number(serverData.gpOwnership)
        ? Number(serverData.gpOwnership)
        : 0;
      serverData.gpCarryProfit = Number(serverData.gpCarryProfit)
        ? Number(serverData.gpCarryProfit)
        : 0;
      serverData.term = Number(serverData.term) ? Number(serverData.term) : 0;
      if (this.title == "Create Thesis") {
        api
          .post(
            `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/thesis`,
            {
              encrypt: {
                data: serverData,
              },
            }
          )
          .then((data) => {
            this.addGpAndCarry()
              .then((response) => {
                this.getThesisData();
                this.$toaster.success("Saved Successfully.");
              })
              .catch((error) => {
                this.$toaster.error("Failed to Insert!!!");
                console.log("error in insering in gp and carry", error);
              });
          })
          .catch((error) => {
            this.$toaster.error("Failed to Insert!!!");
            console.log("error in insering in thesis", error);
          });
      } else {
        if (serverData._id) {
          api
            .patch(
              `/${this.$route.params.account_id}/${serverData._id}/thesis`,
              {
                encrypt: {
                  data: serverData,
                },
              }
            )
            .then((data) => {
              this.editGpAndCarry()
                .then((response) => {
                  this.updateLpDetails()
                    .then((updateResponse) => {
                      self
                        .updateDistributionCallData()
                        .then((updateDistributionsData) => {
                          self
                            .updateDetailsDataDistributions()
                            .then((updateDetailDistributionData) => {
                              self
                                .updateCurrentCapitalCallData()
                                .then((updateCurrenCapitalCallData) => {
                                  self
                                    .updateSummaryData()
                                    .then((updateSummaryData) => {
                                      this.getThesisData();
                                      this.$toaster.success(
                                        "Saved Successfully."
                                      );
                                    });
                                })
                                .catch((error) => {
                                  this.$toaster.error("Failed to update!!!");
                                  console.log(
                                    "error in updateCurrentCapitalCallData in lp details",
                                    error
                                  );
                                });
                            })
                            .catch((error) => {
                              this.$toaster.error("Failed to update!!!");
                              console.log(
                                "error in updateDetailsDataDistributions in lp details",
                                error
                              );
                            });
                        })
                        .catch((error) => {
                          this.$toaster.error("Failed to update!!!");
                          console.log(
                            "error in updateDistributionCallData in lp details",
                            error
                          );
                        });
                    })
                    .catch((error) => {
                      this.$toaster.error("Failed to update!!!");
                      console.log("error in updating in lp details", error);
                    });
                })
                .catch((error) => {
                  this.$toaster.error("Failed to update!!!");
                  console.log("error in updating in gp and carry", error);
                });
            })
            .catch((error) => {
              this.$toaster.error("Failed to update!!!");
              console.log("error in updating in thesis", error);
            });
        }
      }
    },
    getThesisData() {
      const self = this;
      api
        .get(`/${this.$route.params.workspace_id}/thesis`)
        .then((data) => {
          this.thesisRecords = data.data.encrypt.success;
          this.showSpinner = false;
          this.$store.commit(
            "lpAllocations/setThesisData",
            JSON.parse(JSON.stringify(this.thesisRecords))
          );
          if (this.thesisRecords.length == 0) {
            this.handleCreateThesis();
          } else {
            this.showDocument = true;
            this.thesisData =
              this.thesisRecords && this.thesisRecords.length > 0
                ? this.thesisRecords[0]
                : {};
            let value = [];
            value[0] = this.thesisData.hasOwnProperty("checkSizeMin")
              ? this.thesisData.checkSizeMin
              : 0;
            value[1] = this.thesisData.hasOwnProperty("checkSizeMax")
              ? this.thesisData.checkSizeMax
              : 0;
            this.value = value;
            this.sectorValues = this.thesisData.hasOwnProperty("sectors")
              ? this.thesisData.sectors
              : [];
            this.stageValues = this.thesisData.hasOwnProperty("stages")
              ? this.thesisData.stages
              : [];
          }
        })
        .catch((error) => {
          console.log("error in fetching thesis data", error);
        });
    },
    handleCreateThesis() {
      this.title = "Create Thesis";
      this.thesisData = {};
      this.sectorValues = [];
      this.stageValues = [];
      this.value = [];

      let currentWorkspace = this.workspaces.find((item) => {
        if (
          item.workspace &&
          item.workspace._id == this.$route.params.workspace_id
        ) {
          return item;
        }
      });
      
      if (currentWorkspace.workspace) {
        this.thesisData.name = currentWorkspace.workspace.title
          ? currentWorkspace.workspace.title
          : "";
        this.sectorValues =
          currentWorkspace.workspace.sectors &&
          currentWorkspace.workspace.sectors.length > 0
            ? currentWorkspace.workspace.sectors
            : [];
        this.stageValues =
          currentWorkspace.workspace.stages &&
          currentWorkspace.workspace.stages.length > 0
            ? currentWorkspace.workspace.stages
            : [];
        this.value[0] = currentWorkspace.workspace.hasOwnProperty(
          "checkSizeMin"
        )
          ? currentWorkspace.workspace.checkSizeMin
          : 500000;
        this.value[1] = currentWorkspace.workspace.hasOwnProperty(
          "checkSizeMax"
        )
          ? currentWorkspace.workspace.checkSizeMax
          : 4000000;
      }
      this.validations();
      this.showDocument = false;
    },
    handleEditThesis() {
      this.title = "Edit Thesis";
      this.thesisData =
        this.thesisRecords && this.thesisRecords.length > 0
          ? this.thesisRecords[0]
          : {};
      let value = [];
      value[0] = this.thesisData.hasOwnProperty("checkSizeMin")
        ? this.thesisData.checkSizeMin
        : 0;
      value[1] = this.thesisData.hasOwnProperty("checkSizeMax")
        ? this.thesisData.checkSizeMax
        : 0;
      this.value = value;
      this.sectorValues = this.thesisData.hasOwnProperty("sectors")
        ? this.thesisData.sectors
        : [];
      this.stageValues = this.thesisData.hasOwnProperty("stages")
        ? this.thesisData.stages
        : [];
      this.validations();
      this.showDocument = false;
    },
    sizeChange(args) {
      let min, max;
      if (args.value && args.value.length >= 2) {
        min = args.value[0];
        max = args.value[1];
      }
      if (String(min) && String(max)) {
        this.value = [min, max];
      }
    },
    validations() {
      if (
        this.thesisData &&
        this.thesisData.name &&
        this.thesisData.size &&
        this.thesisData.status &&
        this.thesisData.gpOwnership &&
        this.thesisData.gpCarryProfit
      ) {
        this.saveDisable = false;
      } else {
        this.saveDisable = true;
      }
    },
    addGpAndCarry() {
      const self = this;
      let serverData = [];
      let carryObj = {};
      let gpObj = {};
      return new Promise((resolve, reject) => {
        let carryPercentage =
          this.thesisData.gpCarryProfit && Number(this.thesisData.gpCarryProfit)
            ? Number(this.thesisData.gpCarryProfit)
            : 20;
        let ownership =
          this.thesisData.gpOwnership && Number(this.thesisData.gpOwnership)
            ? Number(this.thesisData.gpOwnership)
            : 1;
        carryObj.entity_name = "Carry";
        carryObj.entity_type = "GP Carry";
        carryObj.ownership = 0;
        carryObj.distributions = 0;
        carryObj.profit = Number(carryPercentage);
        carryObj.lp_percentage = 0;
        carryObj.created = new Date();
        carryObj.created_by = this.$route.params.account_id;
        carryObj.workspace = this.$route.params.workspace_id;
        serverData.push(carryObj);
        gpObj.entity_name = "GP";
        gpObj.entity_type = "GP";
        gpObj.ownership = Number(ownership);
        gpObj.capital_commitment = Number(
          (
            Number(gpObj.ownership / 100) * Number(this.thesisData.size)
          ).toFixed(2)
        );
        gpObj.lp_percentage = 0;
        gpObj.profit = Number(
          (
            1 -
            Number(Number(carryPercentage) / 100) * Number(ownership)
          ).toFixed(2)
        );
        gpObj.capital_called = 0;
        gpObj.contributed_to_date = 0;
        gpObj.open_balance = 0;
        gpObj.remaining_commitment = Number(gpObj.capital_commitment);
        gpObj.distributions = 0;
        gpObj.created = new Date();
        gpObj.created_by = this.$route.params.account_id;
        gpObj.workspace = this.$route.params.workspace_id;
        serverData.push(gpObj);
        self.$store
          .dispatch("lpAllocations/apiBulkPostDetailsData", serverData)
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    editGpAndCarry() {
      const self = this;
      let serverData = self.$store.getters["lpAllocations/gpDetailsData"];
      let carryPercentage =
        this.thesisData.gpCarryProfit && Number(this.thesisData.gpCarryProfit)
          ? Number(this.thesisData.gpCarryProfit)
          : 20;
      let ownership =
        this.thesisData.gpOwnership && Number(this.thesisData.gpOwnership)
          ? Number(this.thesisData.gpOwnership)
          : 1;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (serverData && serverData.length > 0) {
          serverData.map((item) => {
            if (
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "GP Carry"
            ) {
              item.profit = Number(carryPercentage);
            }
            if (
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "GP"
            ) {
              item.ownership = Number(ownership);
              item.capital_commitment = Number(
                (
                  Number(item.ownership / 100) * Number(this.thesisData.size)
                ).toFixed(2)
              );
              item.profit = Number(
                (
                  1 -
                  Number(Number(carryPercentage) / 100) * Number(ownership)
                ).toFixed(2)
              );
              if (
                item.hasOwnProperty("capital_called") &&
                item.hasOwnProperty("open_balance")
              ) {
                item.remaining_commitment = Number(
                  (
                    Number(item.capital_commitment) -
                    Number(item.capital_called) +
                    Number(item.open_balance)
                  ).toFixed(2)
                );
              }
            }
            payload.push(item);
          });
          
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateLpDetails() {
      const self = this;
      let payload = [];
      return new Promise((resolve, reject) => {
        self
          .updateGpDetails()
          .then((data) => {
            self
              .updateLpOwnership()
              .then((ownershipData) => {
                let gpData = self.$store.getters["lpAllocations/gpDetailsData"];
                let lpData = self.$store.getters["lpAllocations/lpDetailsData"];
                let detailsData =
                  self.$store.getters["lpAllocations/detailsData"];
                let summaryData =
                  self.$store.getters["lpAllocations/summaryData"];
                summaryData =
                  summaryData && summaryData.length > 0 ? summaryData[0] : {};
                let fundDetails =
                  self.$store.getters["lpAllocations/fundDetailsData"];
                let fundDetailsCapitalCommitment =
                  fundDetails &&
                  fundDetails.length > 0 &&
                  fundDetails[0] &&
                  fundDetails[0].hasOwnProperty("capital_commitment") &&
                  Number(fundDetails[0].capital_commitment)
                    ? Number(fundDetails[0].capital_commitment)
                    : 0;
                let fundDetailsFundPercentage =
                  fundDetails &&
                  fundDetails.length > 0 &&
                  fundDetails[0] &&
                  fundDetails[0].hasOwnProperty("ownership") &&
                  Number(fundDetails[0].ownership)
                    ? Number(fundDetails[0].ownership)
                    : 0;
                if (detailsData && detailsData.length > 0) {
                  let totalLpCommitment = 0;
                  let gpCarry = 0;
                  detailsData.map((item) => {
                    if (
                      item &&
                      item.hasOwnProperty("entity_type") &&
                      item.entity_type == "LP"
                    ) {
                      if (
                        item.hasOwnProperty("capital_commitment") &&
                        Number(item.capital_commitment) > 0
                      ) {
                        totalLpCommitment += Number(item.capital_commitment);
                      }
                    }
                    if (
                      item &&
                      item.hasOwnProperty("entity_type") &&
                      item.entity_type == "GP Carry"
                    ) {
                      if (
                        item.hasOwnProperty("profit") &&
                        Number(item.profit) > 0
                      ) {
                        gpCarry = Number(item.profit);
                      }
                    }
                  });
                  detailsData.map((item) => {
                    let capitalCommitment =
                      item.hasOwnProperty("capital_commitment") &&
                      Number(item.capital_commitment) > 0
                        ? Number(item.capital_commitment)
                        : 0;
                    let contributedToDate =
                      item.contributed_to_date &&
                      Number(item.contributed_to_date) > 0
                        ? Number(item.contributed_to_date)
                        : 0;
                    item.capital_called =
                      capitalCommitment &&
                      summaryData &&
                      summaryData.hasOwnProperty("capital_called_to_date") &&
                      Number(summaryData.capital_called_to_date) > 0
                        ? Number(
                            (
                              Number(capitalCommitment) *
                              (Number(summaryData.capital_called_to_date) / 100)
                            ).toFixed(2)
                          )
                        : 0;
                    let capitalCalled =
                      item.capital_called && Number(item.capital_called) > 0
                        ? Number(item.capital_called)
                        : 0;
                    if (item.entity_type == "LP") {
                      item.ownership = Number(
                        (
                          (Number(capitalCommitment) /
                            Number(fundDetailsCapitalCommitment)) *
                          100
                        ).toFixed(2)
                      );
                    }
                    let ownership =
                      item.hasOwnProperty("ownership") &&
                      Number(item.ownership) > 0
                        ? Number(item.ownership)
                        : 0;
                    item.lp_percentage =
                      item.entity_type == "LP"
                        ? Number(
                            (
                              (Number(capitalCommitment) /
                                Number(totalLpCommitment)) *
                              100
                            ).toFixed(2)
                          )
                        : 0;
                    item.open_balance = Number(
                      (
                        Number(capitalCalled) - Number(contributedToDate)
                      ).toFixed(2)
                    );
                    item.remaining_commitment = Number(
                      (
                        Number(capitalCommitment) -
                        Number(capitalCalled) +
                        Number(item.open_balance)
                      ).toFixed(2)
                    );
                    if (item.entity_type == "LP" || item.entity_type == "GP") {
                      item.profit = Number(
                        (
                          (Number(Number(fundDetailsFundPercentage) / 100) -
                            Number(Number(gpCarry) / 100)) *
                          Number(ownership)
                        ).toFixed(2)
                      );
                    }
                    if (
                      summaryData &&
                      summaryData.hasOwnProperty("distributions") &&
                      summaryData.hasOwnProperty("distributions_pre_carry") &&
                      summaryData.hasOwnProperty("distributions_in_carry") &&
                      Number(summaryData.distributions) > 0 &&
                      Number(summaryData.distributions_pre_carry) &&
                      Number(summaryData.distributions_in_carry)
                    ) {
                      if (
                        summaryData.hasOwnProperty("distributed_to_date") &&
                        summaryData.hasOwnProperty("capital_commitment") &&
                        Number(summaryData.distributed_to_date) >
                          Number(summaryData.capital_commitment)
                      ) {
                        //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                        item.distributions = Number(
                          (
                            Number(summaryData.distributions_pre_carry) *
                              (Number(ownership) / 100) +
                            Number(summaryData.distributions_in_carry) *
                              (Number(item.profit) / 100)
                          ).toFixed(2)
                        );
                      } else {
                        //distrubutions=distributed to date of summary*ownership%
                        item.distributions =
                          (item.entity_type == "LP" ||
                            item.entity_type == "GP") &&
                          Number(summaryData.distributed_to_date) > 0 &&
                          Number(ownership) > 0
                            ? Number(
                                (
                                  Number(summaryData.distributed_to_date) *
                                  Number(Number(ownership) / 100)
                                ).toFixed(2)
                              )
                            : 0;
                      }
                    }
                    payload.push(item);
                  });
                  self.$store
                    .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
                    .then((data) => {
                      resolve(data);
                    })
                    .catch((error) => {
                      reject(error);
                    });
                } else {
                  resolve();
                }
              })
              .catch((error) => {
                this.$toaster.error("Fail to update");
                console.log(
                  "error in updating lp ownership details inside update lp details",
                  error
                );
              });
          })
          .catch((error) => {
            this.$toaster.error("Fail to update");
            console.log(
              "error in updating gp details inside update lp details",
              error
            );
          });
      });
    },
    updateGpDetails() {
      const self = this;
      let gpData = self.$store.getters["lpAllocations/gpDetailsData"];
      let detailsData = self.$store.getters["lpAllocations/detailsData"];
      let summaryData = self.$store.getters["lpAllocations/summaryData"];
      let fundDetails = self.$store.getters["lpAllocations/fundDetailsData"];
      let fundDetailsCapitalCommitment =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("capital_commitment") &&
        Number(fundDetails[0].capital_commitment)
          ? Number(fundDetails[0].capital_commitment)
          : 0;
      let fundDetailsFundPercentage =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("ownership") &&
        Number(fundDetails[0].ownership)
          ? Number(fundDetails[0].ownership)
          : 0;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (detailsData && detailsData.length > 0) {
          let totalLpCommitment = 0;
          let gpCarry = 0;
          detailsData.map((item) => {
            if (
              item &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "LP"
            ) {
              if (
                item.hasOwnProperty("capital_commitment") &&
                Number(item.capital_commitment) > 0
              ) {
                totalLpCommitment += Number(item.capital_commitment);
              }
            }
            if (
              item &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "GP Carry"
            ) {
              if (item.hasOwnProperty("profit") && Number(item.profit) > 0) {
                gpCarry = Number(item.profit);
              }
            }
          });
          gpData.map((item) => {
            let ownership =
              item.hasOwnProperty("ownership") && Number(item.ownership) > 0
                ? Number(item.ownership)
                : 0;
            if (item.entity_type == "GP") {
              //gp% of lp capital commitment
              
              item.capital_commitment = Number(
                (
                  Number(Number(item.ownership) / 100) *
                  Number(totalLpCommitment || self.thesisData.size)
                ).toFixed(2)
              );
              item.profit = Number(
                (
                  (Number(Number(fundDetailsFundPercentage) / 100) -
                    Number(Number(gpCarry) / 100)) *
                  Number(ownership)
                ).toFixed(2)
              );
              item.capital_called =
                item.capital_commitment &&
                summaryData &&
                summaryData.hasOwnProperty("capital_called_to_date") &&
                Number(summaryData.capital_called_to_date) > 0
                  ? Number(
                      (
                        Number(item.capital_commitment) *
                        (Number(summaryData.capital_called_to_date) / 100)
                      ).toFixed(2)
                    )
                  : 0;
              item.open_balance =
                item.hasOwnProperty("contributed_to_date") &&
                Number(item.contributed_to_date)
                  ? Number(
                      (
                        Number(item.capital_called) -
                        Number(item.contributed_to_date)
                      ).toFixed(2)
                    )
                  : 0;
              item.remaining_commitment = Number(
                (
                  Number(item.capital_commitment) -
                  Number(item.capital_called) +
                  Number(item.open_balance)
                ).toFixed(2)
              );
            }
            if (
              summaryData &&
              summaryData.hasOwnProperty("distributions") &&
              summaryData.hasOwnProperty("distributions_pre_carry") &&
              summaryData.hasOwnProperty("distributions_in_carry") &&
              Number(summaryData.distributions) > 0 &&
              Number(summaryData.distributions_pre_carry) &&
              Number(summaryData.distributions_in_carry)
            ) {
              if (
                summaryData.hasOwnProperty("distributed_to_date") &&
                summaryData.hasOwnProperty("capital_commitment") &&
                Number(summaryData.distributed_to_date) >
                  Number(summaryData.capital_commitment)
              ) {
                //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                item.distributions = Number(
                  (
                    Number(summaryData.distributions_pre_carry) *
                      (Number(ownership) / 100) +
                    Number(summaryData.distributions_in_carry) *
                      (Number(item.profit) / 100)
                  ).toFixed(2)
                );
              } else {
                //distrubutions=distributed to date of summary*ownership%
                item.distributions =
                  item.entity_type == "GP" &&
                  Number(summaryData.distributed_to_date) > 0 &&
                  Number(ownership) > 0
                    ? Number(
                        (
                          Number(summaryData.distributed_to_date) *
                          Number(Number(ownership) / 100)
                        ).toFixed(2)
                      )
                    : 0;
              }
            }
            payload.push(item);
          });
          
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateLpOwnership() {
      const self = this;
      let lpData = self.$store.getters["lpAllocations/lpDetailsData"];
      let detailsData = self.$store.getters["lpAllocations/detailsData"];
      let fundDetails = self.$store.getters["lpAllocations/fundDetailsData"];
      let fundDetailsCapitalCommitment =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("capital_commitment") &&
        Number(fundDetails[0].capital_commitment)
          ? Number(fundDetails[0].capital_commitment)
          : 0;
      let fundDetailsFundPercentage =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("ownership") &&
        Number(fundDetails[0].ownership)
          ? Number(fundDetails[0].ownership)
          : 0;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (lpData && lpData.length > 0) {
          let totalLpCommitment = 0;
          // lpData.map((item) => {
          //   if (
          //     item &&
          //     item.hasOwnProperty("entity_type") &&
          //     item.entity_type == "LP"
          //   ) {
          //     if (
          //       item.hasOwnProperty("capital_commitment") &&
          //       Number(item.capital_commitment) > 0
          //     ) {
          //       totalLpCommitment += Number(item.capital_commitment);
          //     }
          //   }
          // });
          lpData.map((item) => {
            let capitalCommitment =
              item.hasOwnProperty("capital_commitment") &&
              Number(item.capital_commitment) > 0
                ? Number(item.capital_commitment)
                : 0;
            if (item.entity_type == "LP") {
              item.ownership = Number(
                (
                  (Number(capitalCommitment) /
                    Number(fundDetailsCapitalCommitment)) *
                  100
                ).toFixed(2)
              );
            }
            payload.push(item);
            
            self.$store
              .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else {
          resolve();
        }
      });
    },
    updateCurrentCapitalCallData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let lpDetailsData = self.$store.getters["lpAllocations/lpDetailsData"];
      return new Promise((resolve, reject) => {
        if (
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("_id")
        ) {
          let totalLpCapitalCalled = 0;
          let totalLpDistributions = 0;
          let totalFundCapitalCalled =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_called") &&
            Number(fundDetailsData[0].capital_called) > 0
              ? Number(fundDetailsData[0].capital_called)
              : 0;
          let totalFundDistributions =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("distributions") &&
            Number(fundDetailsData[0].distributions) > 0
              ? Number(fundDetailsData[0].distributions)
              : 0;
          let serverData = JSON.parse(JSON.stringify(currentCapitalCallData));
          let previousValue =
            currentCapitalCallData &&
            currentCapitalCallData.hasOwnProperty(
              "capital_called_to_date_amount"
            )
              ? Number(currentCapitalCallData.capital_called_to_date_amount)
              : 0;
          let previouCapitalCalledAmountValue =
            currentCapitalCallData &&
            currentCapitalCallData.hasOwnProperty("capital_called_amount")
              ? Number(currentCapitalCallData.capital_called_amount)
              : 0;
          let presentValue = Number(
            (
              Number(previousValue) - Number(previouCapitalCalledAmountValue)
            ).toFixed(2)
          );
          if (lpDetailsData && lpDetailsData.length > 0) {
            lpDetailsData.map((item) => {
              if (
                item &&
                item.hasOwnProperty("capital_called") &&
                Number(item.capital_called) > 0
              ) {
                totalLpCapitalCalled += Number(item.capital_called);
              }
              if (
                item &&
                item.hasOwnProperty("distributions") &&
                Number(item.distributions) > 0
              ) {
                totalLpDistributions += Number(item.distributions);
              }
            });
          }
          serverData.capital_called_amount =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_commitment") &&
            Number(fundDetailsData[0].capital_commitment) > 0
              ? Number(
                  (
                    Number(serverData.capital_called / 100) *
                    Number(fundDetailsData[0].capital_commitment)
                  ).toFixed(2)
                )
              : 0;
          serverData.capital_called_to_date_amount = Number(
            (
              Number(presentValue) + Number(serverData.capital_called_amount)
            ).toFixed(2)
          );
          serverData.moic =
            Number(this.portfolioValue) > 0 && Number(this.portfolioCost) > 0
              ? Number(
                  (
                    Number(this.portfolioValue) / Number(this.portfolioCost)
                  ).toFixed(2)
                )
              : 0;
          serverData.tvpi =
            Number(totalLpCapitalCalled) > 0
              ? Number(
                  (
                    Number(this.portfolioValue) / Number(totalLpCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          serverData.net_dpi =
            Number(totalLpCapitalCalled) > 0
              ? Number(
                  (
                    Number(totalLpDistributions) / Number(totalLpCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          serverData.gross_dpi =
            Number(totalFundCapitalCalled) > 0
              ? Number(
                  (
                    Number(totalFundDistributions) /
                    Number(totalFundCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          if (serverData.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchCapitalCallData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    updateSummaryData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let summaryData = self.$store.getters["lpAllocations/summaryData"];
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      return new Promise((resolve, reject) => {
        let serverData =
          summaryData && summaryData.length > 0
            ? JSON.parse(JSON.stringify(summaryData[0]))
            : {};
        serverData.capital_called =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called") &&
          Number(currentCapitalCallData.capital_called) > 0
            ? Number(currentCapitalCallData.capital_called)
            : 0;
        serverData.capital_called_to_date =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called_to_date") &&
          Number(currentCapitalCallData.capital_called_to_date) > 0
            ? Number(currentCapitalCallData.capital_called_to_date)
            : 0;
        serverData.capital_called_amount =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called_amount") &&
          Number(currentCapitalCallData.capital_called_amount) > 0
            ? Number(currentCapitalCallData.capital_called_amount)
            : 0;
        serverData.capital_called_to_date_amount =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty(
            "capital_called_to_date_amount"
          ) &&
          Number(currentCapitalCallData.capital_called_to_date_amount) > 0
            ? Number(currentCapitalCallData.capital_called_to_date_amount)
            : 0;
        serverData.current_capital_call =
          currentCapitalCallData && currentCapitalCallData.hasOwnProperty("_id")
            ? currentCapitalCallData._id
            : "";
        serverData.moic =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("moic") &&
          Number(currentCapitalCallData.moic) > 0
            ? Number(currentCapitalCallData.moic)
            : 0;
        serverData.tvpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("tvpi") &&
          Number(currentCapitalCallData.tvpi) > 0
            ? Number(currentCapitalCallData.tvpi)
            : 0;
        serverData.net_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("net_dpi") &&
          Number(currentCapitalCallData.net_dpi) > 0
            ? Number(currentCapitalCallData.net_dpi)
            : 0;
        serverData.gross_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("gross_dpi") &&
          Number(currentCapitalCallData.gross_dpi) > 0
            ? Number(currentCapitalCallData.gross_dpi)
            : 0;
        serverData.capital_commitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment) > 0
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        serverData.distributions =
          currentDistributionData.hasOwnProperty("distributions") &&
          Number(currentDistributionData.distributions)
            ? Number(currentDistributionData.distributions)
            : 0;
        serverData.distributions_pre_carry =
          currentDistributionData.hasOwnProperty("distributions_pre_carry") &&
          Number(currentDistributionData.distributions_pre_carry)
            ? Number(currentDistributionData.distributions_pre_carry)
            : 0;
        serverData.distributions_in_carry =
          currentDistributionData.hasOwnProperty("distributions_in_carry") &&
          Number(currentDistributionData.distributions_in_carry)
            ? Number(currentDistributionData.distributions_in_carry)
            : 0;
        serverData.distributed_to_date =
          currentDistributionData.hasOwnProperty("distributed_to_date") &&
          Number(currentDistributionData.distributed_to_date)
            ? Number(currentDistributionData.distributed_to_date)
            : 0;
        serverData.current_distribution =
          currentDistributionData &&
          currentDistributionData.hasOwnProperty("_id")
            ? currentDistributionData._id
            : "";
        if (summaryData && summaryData.length > 0) {
          if (serverData && serverData.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchSummaryData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          self.$store
            .dispatch("lpAllocations/apiPostSummaryData", serverData)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    updateDistributionCallData() {
      const self = this;
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      return new Promise((resolve, reject) => {
        if (
          currentDistributionData &&
          currentDistributionData.hasOwnProperty("_id")
        ) {
          let serverData = JSON.parse(JSON.stringify(currentDistributionData));
          serverData.distributed_to_date = serverData.hasOwnProperty(
            "distributed_to_date"
          )
            ? Number(serverData.distributed_to_date)
            : 0;
          serverData.distributions_in_carry =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_commitment") &&
            Number(fundDetailsData[0].capital_commitment)
              ? Number(
                  (
                    Number(serverData.distributed_to_date) -
                    Number(fundDetailsData[0].capital_commitment)
                  ).toFixed(2)
                )
              : 0;
          serverData.distributions_pre_carry = Number(
            (
              Number(serverData.distributed_to_date) -
              Number(serverData.distributions_in_carry)
            ).toFixed(2)
          );
          self.$store
            .dispatch("lpAllocations/apiPatchDistributionData", serverData)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateDetailsDataDistributions() {
      const self = this;
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      let detailsData = self.$store.getters["lpAllocations/detailsData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let payload = [];
      return new Promise((resolve, reject) => {
        let capitalCommitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment)
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        if (detailsData && detailsData.length > 0) {
          detailsData.map((item) => {
            let ownership =
              item.hasOwnProperty("ownership") && Number(item.ownership)
                ? Number(item.ownership)
                : 0;
            let profit =
              item.hasOwnProperty("profit") && Number(item.profit)
                ? Number(item.profit)
                : 0;
            if (
              currentDistributionData &&
              currentDistributionData.hasOwnProperty("distributions") &&
              currentDistributionData.hasOwnProperty(
                "distributions_pre_carry"
              ) &&
              currentDistributionData.hasOwnProperty(
                "distributions_in_carry"
              ) &&
              Number(currentDistributionData.distributions) > 0 &&
              Number(currentDistributionData.distributions_pre_carry) &&
              Number(currentDistributionData.distributions_in_carry)
            ) {
              if (
                currentDistributionData.hasOwnProperty("distributed_to_date") &&
                capitalCommitment &&
                Number(capitalCommitment) &&
                Number(currentDistributionData.distributed_to_date) >
                  Number(capitalCommitment)
              ) {
                //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                item.distributions = Number(
                  (
                    Number(currentDistributionData.distributions_pre_carry) *
                      (Number(ownership) / 100) +
                    Number(currentDistributionData.distributions_in_carry) *
                      (Number(profit) / 100)
                  ).toFixed(2)
                );
              } else {
                //distrubutions=distributed to date of summary*ownership%
                item.distributions =
                  (item.entity_type == "LP" || item.entity_type == "GP") &&
                  Number(currentDistributionData.distributed_to_date) > 0 &&
                  Number(ownership) > 0
                    ? Number(
                        (
                          Number(currentDistributionData.distributed_to_date) *
                          Number(Number(ownership) / 100)
                        ).toFixed(2)
                      )
                    : 0;
              }
            }
            payload.push(item);
          });
          
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
  },
  created() {
    this.type = "Range";
    this.mintype = "MinRange";
    this.step = 10000;
    this.tooltip = {
      placement: "Before",
      isVisible: true,
      format: "C2",
      showOn: "Hover",
    };
    this.ticks = {
      placement: "After",
      format: "C2",
      largeStep: 1000000,
      smallStep: 1000000,
      showSmallTicks: true,
    };
    this.min = 1000;
    this.max = 10000000;
    this.height = 8;
    this.dotWidth = "22";
    this.bgStyle = {
      backgroundColor: "#fff",
      boxShadow: "inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)",
    };
    this.tooltipStyle = {
      backgroundColor: "#FFD939",
      borderColor: "#FFD939",
    };
    this.absorb = true;
    this.processStyle = {
      backgroundColor: "#FFD939",
    };
    this.marks = 10000;
    this.tooltipMerge = true;
    this.formatter = (value) =>
      `${this.formatCurrency(value, this.currency.ref, 0, true)}`;
  },
  mounted() {
    this.getThesisData();
  },
  beforeCreate: function () {
    document.body.className = "sidebar-mini createThesis pageMainScroll";
  },
  destroyed() {
    document.body.className = "pageMainScroll sidebar-mini";
  },
};
</script>
<style lang="scss">
.createThesis.e-tooltip-wrap {
  z-index: 3 !important;
}

.nextBtn {
  height: 35px;
  color: #5445f3;
  background: #fff 0% 0% no-repeat padding-box;
  border-radius: 4px;
  width: 59px;
  border: 0px;
  cursor: pointer;
}
.sectorStatusMultiselectDropdown .multiselect__tags {
  max-width: 305px;
  min-width: 100%;
  width: 100%;
}
</style>